import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer, real, text } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

export const graphemeBiauTable = staticTable(
  "grapheme_biau",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    /** 1-based frequency rank (1 = most frequent). From BIAU1.TXT (字頻總表) row order. */
    rank: integer("rank").notNull(),

    /** Kangxi radical (部首) of the character, or null when the source cell is EUDC. */
    radical: text("radical"),

    /** Raw occurrence count in the BIAU sample corpus. */
    frequency: integer("frequency").notNull(),

    /** Running sum of frequency up to and including this row. */
    cumulativeFrequency: integer("cumulative_frequency").notNull(),

    /** Running cumulative coverage as a percent (0–100). */
    cumulativePercent: real("cumulative_percent").notNull(),
  },
  (table) => [
    index("grapheme_biau_grapheme_id_idx").on(table.graphemeId),
    index("grapheme_biau_rank_idx").on(table.rank),
  ],
);

export type GraphemeBiau = typeof graphemeBiauTable.$inferSelect;
